<template>
  <Layout :footer-style="2" header-class="header-left-align" nav-alignment="right" :header-transparency="false" :show-top-header="true" buy-button-class="btn-default btn-small">

    <!-- Start Contact Area  -->
    <div class="rwt-contact-area rn-section-gap">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 mb--40">
            <SectionTitle
                subtitle="YAO XIE GONG MAO"
                text-align="center"
                title="联系我们"
                data-aos="fade-up"
            />
          </div>
        </div>
        <div class="row row--15">
          <div class="col-lg-12">
            <div class="rn-contact-address mt_dec--30">
              <div class="row">
                <div class="col-lg-4 col-md-6 col-12">
                  <div class="rn-address">
                    <div class="icon">
                      <Icon name="headphones" :size="40"/>
                      <h4 class="title">联系方式</h4>
                    </div>
                    <div class="inner">
<!--                      <h4 class="title">联系方式</h4>-->
                      <p v-for="item in phones">{{ item.item1 }}</p>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 col-12">
                  <div class="rn-address">
                    <div class="icon">
                      <Icon name="mail" :size="40"/>
                      <h4 class="title">邮箱地址</h4>
                    </div>
                    <div class="inner">

                      <p v-for="item in emails">{{ item.item1 }}</p>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 col-12">
                  <div class="rn-address">
                    <div class="icon">
                      <Icon name="map-pin" :size="40"/>
                      <h4 class="title">位置信息</h4>
                    </div>
                    <div class="inner">

                      <p v-for="item in addresses">{{ item.item1 }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt--40 row--15">
          <div class="col-lg-5">
            <ContactForm/>
          </div>
          <div class="col-lg-7 mt_md--30 mt_sm--30">
            <GoogleMap/>
          </div>
        </div>
      </div>
    </div>
    <!-- End Contact Area  -->
  </Layout>
</template>

<script>
import Layout from '../../components/common/Layout'
import Breadcrumb from '../../components/elements/breadcrumb/Breadcrumb'
import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
import Icon from "../../components/icon/Icon";
import GoogleMap from "../../components/elements/contact/GoogleMap";
import ContactForm from "../../components/elements/contact/ContactForm";

export default {
  name: 'ContactUs',
  components: {ContactForm, GoogleMap, Icon, SectionTitle, Breadcrumb, Layout},
  data(){
    return{
      phones:[],
      emails:[],
      addresses:[]
    }
  },
  created() {
    this.getFootContact();
  },
  methods:{
    getFootContact(){
      this.getRequest("/system/web/getFootContact").then(resp=>{

        this.phones = resp.data.phones;
        this.emails = resp.data.emails;
        this.addresses = resp.data.addresses;

      })
    }
  }
}
</script>